export const DASHBOARD_DOM_ID = 'dashboard_page_iframe';
